import { AuthenticationState } from 'react-aad-msal';
export const isAuthenticatedSelector = (store) => store.authenticationState.initialized && store.authenticationState.state === AuthenticationState.Authenticated;
export const isAuthenticationInitialized = (store) => store.authenticationState.initialized;
export const aadAccountSelector = (store) => store.authenticationState.account;
